import "webdatarocks/webdatarocks.css";
import React, { useEffect, useRef, useState } from "react";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import WebDataRocks from "webdatarocks";
import LoadingRaport from "./LoadingRaport";
import useAssets from "../../../store/ReactQueries/assets/asset/useAsset";

const rowsName = ["Barcode", "Title", "Description", "Asset Category", "Asset Type", "Location", "Asset Department", "Asset Status", "Created Date", "Updated Date"];

const AssetsRaport = () => {

  const pivotRef = useRef<HTMLDivElement>(null);
  let { data: assets, isLoading, error: ticketErrors } = useAssets(0, 0);
  const [loading, setLoading] = useState<boolean>(true);
  const { darkMode } = useDarkModeStore();

  useEffect(() => {
    if (pivotRef.current && assets && !isLoading && !ticketErrors) {
      setLoading(true);

      const assetsData = assets?.map((asset) => ({
        Barcode: `${asset.barcode.toString()}`,
        Title: asset.title,
        Description: asset.description,
        "Asset Category": asset.assetCategory?.title,
        "Asset Type": asset.assetType?.title,
        "Location": asset.location?.title,
        "Asset Department": asset.assetDepartment?.title,
        "Asset Status": asset.assetStatus?.title || "",
        "Created Date":
          asset.createdDate && new Date(asset.createdDate).toLocaleDateString(),
        "Updated Date":
          asset.updatedDate && new Date(asset.updatedDate).toLocaleDateString(),
      }));
      new WebDataRocks({
        container: pivotRef.current,
        toolbar: true,
        height: "100%",
        width: "100%",
        report: {
          dataSource: {
            data: assetsData,
          },
          options: {
            grid: {
              type: "flat",
              showGrandTotals: "off",
              showTotals: "off",
            },
          },
          slice: {
            rows: rowsName.map(uniqueName => ({ uniqueName })),
            columns: [],
            measures: [],
          },
        },
        reportcomplete: () => {
          setTimeout(() => {
            setLoading(false);
          }, 500)
        },
      });
    }
  }, [assets, isLoading, ticketErrors, darkMode]);

  return (
    <div className="mb-4" style={{ height: "83vh", position: "relative" }}>
      {loading && <LoadingRaport />}
      <div ref={pivotRef} />
    </div>
  );
};

export default AssetsRaport;
